const EditablePriceField = ({ price, setPrice, isLoading }) => (
    <div className='mt-4 mb-4'>
      <label className='block text-sm font-medium font-inter text-gray-600 mb-2'>
        Product Price<span className='text-red-500'>*</span>
      </label>
      <input
        type="number"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        disabled={isLoading}
        className='bg-[#F5EFE7] border-b border-black shadow-md w-full h-[45px] rounded-[3.39px] px-4'
        required
      />
    </div>
  );

  export default EditablePriceField;